import React from "react";

import { forms } from "src/modules/ktx/forms";
import { FormExplorer as FormExplorerBare } from "src/modules/shared/form-explorer";

export const FormExplorer: React.FunctionComponent = () => (
	<FormExplorerBare forms={forms} />
);
